import actionTypes from '../constants/action-types';

function customization(state = {}, action) {
  switch (action.type) {
    case actionTypes.SET_CUSTOMIZATION_CONFIGURATION: {
      return action.payload.customization;
    }

    case actionTypes.SET_COLOR_PALETTE_CONFIG: {
      return {
        ...state,
        colorPaletteConfig: {
          ...action.payload.config,
        },
      };
    }

    default:
      return state;
  }
}

export default customization;
